import '@rei/cedar/dist/cdr-reset.css';
import '@rei/cedar/dist/cdr-fonts.css';

import '@rei/cedar/dist/style/cdr-grid.css';
import '@rei/cedar/dist/style/cdr-link.css';
import '@rei/cedar/dist/style/cdr-list.css';
import '@rei/cedar/dist/style/cdr-accordion.css';
import '@rei/cedar/dist/style/cdr-text.css';
import '@rei/cedar/dist/style/cdr-table.css';
import '@rei/cedar/dist/style/cdr-accordion-group.css';
import '@rei/cedar/dist/style/cdr-input.css';
import '@rei/cedar/dist/style/cdr-switch.css';

import '@rei/frequently-asked-questions/dist/style.css';

import '../../../style/gladlyChat.scss';

import createApp from '@returns-page/main.mts';
import { getClientPageData } from '@utils/helpers.mts';

const { pageData: props } = getClientPageData();
const { app } = createApp(props);

app.mount('#app');
